import { modelFamiliesAndLinesCA, models } from '../constants/vehicles';

export const modelFamiliesOptions = Object.keys(modelFamiliesAndLinesCA).map((family) => ({
  key: family,
  value: family, // this will be sent to the backend
  label: family, // this is the user-facing label
}));

export const modelLinesByFamilyOptions = models.reduce(
  (acc, item) => {
    const { model, modelOfInterest, modelDeviation } = item;

    const family = Object.entries(modelFamiliesAndLinesCA).find(([_, lines]) =>
      lines.includes(model),
    )?.[0];

    if (!family) return acc;

    if (!acc[family]) acc[family] = [];

    const compositeCode = `${modelOfInterest}_${modelDeviation}`;

    acc[family].push({
      key: compositeCode,
      value: compositeCode,
      label: model,
    });

    return acc;
  },
  {} as Record<string, { key: string; value: string; label: string }[]>,
);
